function Mexico({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1644)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M32 16.0003C32 9.65689 28.3085 4.17589 22.9565 1.58789V30.4126C28.3085 27.8246 32 22.3436 32 16.0003Z" fill="#D80027"/>
  <path d="M0 16.0003C0 22.3436 3.69156 27.8246 9.0435 30.4126V1.58789C3.69156 4.17589 0 9.65689 0 16.0003Z" fill="#6DA544"/>
  <path d="M11.826 16.0007C11.826 18.3059 13.6948 20.1746 16 20.1746C18.3052 20.1746 20.1739 18.3059 20.1739 16.0007V14.6094H11.826V16.0007Z" fill="#6DA544"/>
  <path d="M21.5652 13.2175H17.3913C17.3913 12.4491 16.7683 11.8262 15.9999 11.8262C15.2316 11.8262 14.6086 12.4491 14.6086 13.2175H10.4347C10.4347 13.9859 11.104 14.6088 11.8723 14.6088H11.826C11.826 15.3772 12.4489 16.0001 13.2173 16.0001C13.2173 16.7685 13.8402 17.3914 14.6086 17.3914H17.3913C18.1597 17.3914 18.7826 16.7685 18.7826 16.0001C19.551 16.0001 20.1739 15.3772 20.1739 14.6088H20.1275C20.8959 14.6088 21.5652 13.9859 21.5652 13.2175Z" fill="#FF9811"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Mexico;
